export default __webpack_public_path__ + "static/media/Staff1.1266ef8f.JPG";